import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { useEffect } from 'react'
import { mapSelectValue } from '../../../utils'

const MoInformationform = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postmoonline, getmodetails, modetailsData } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const intialValues = {
        filingstatus: '',
        additionalamount: '',
        exemptstatus: null,
        reducedwithholding: ''
    }

    useEffect(() => {
        getmodetails(initializestore?.initializeData?.userkey)
    }, [])

    const w4schema = () => {
        const baseSchema = {
            filingstatus: yup.string().required('Filing Status is a required field'),
            additionalamount: yup
                .string().nullable(),
            exemptstatus: yup.string().nullable(),
            reducedwithholding: yup
                .string()
                .nullable()
        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    const options1 = [
        {
            key: 1, value: 'Single or Married Spouse Works or Married Filing Separate'
        },

        { key: 2, value: 'Married (Spouse does not work)' },
        { key: 3, value: 'Head of Household' },
    ]
    const options2 = [
        {
            key: 1,
            value:
                'I am exempt because I had a right to a refund of all Missouri income tax withheld last year and expect to have no tax liability this year. A new MO W-4 must be completed annually if you wish to continue the exemption'
        },
        {
            key: 2,
            value:
                'I am exempt because I meet the conditions set forth under the Servicemember Civil Relief Act, as amended by the Military Spouses Residency Relief Act and have no Missouri tax liability'
        },
        {
            key: 3,
            value:
                'I am exempt because my income is earned as a member of any active duty component of the Armed Forces of the United States and I am eligible for the military income deduction.'
        },

    ]

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MO Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey: initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            filingStatus: values?.filingstatus,
                            exemptStatus: values?.exemptstatus ?? null,
                            additionalWithholding: values?.additionalamount ? values?.additionalamount : null,
                            reducedWithholding: values?.reducedwithholding ? values?.reducedwithholding : null,
                            employersName: modetailsData?.data?.employersName,
                            employerAddress: modetailsData?.data?.employerAddress,
                            employerCity: modetailsData?.data?.city,
                            employerState: modetailsData?.data?.state,
                            employerZipCode: modetailsData?.data?.zipCode,
                            employerHireDate: modetailsData?.data?.hireDate,
                            employerFederalEmployerIDNumber: modetailsData?.data?.federalEmployerIDNumber,
                            employerMissouriTaxIdentificationNumber: modetailsData?.data?.taxIdentificationNumber
                        }

                        const response = await postmoonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('MoInformationonline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <View>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Filing Status: Check the appropriate filling status below *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Filing Status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.filingstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('filingstatus', option)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.filingstatus &&
                                            props.errors.filingstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.filingstatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {(props.values.exemptstatus === null || props.values.exemptstatus === '') && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '65%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Additional withholding: If you expect to have a balance due (as a result of interest income, dividends, income from a part-time job, etc.) on your tax return, you may request your employer to withhold an additional amount of tax from each pay period. To calculate the amount needed, divide the amount of the expected tax by the number of pay periods in a year. Enter the additional amount to be withheld each pay period on line 2'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalamount}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalamount')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalamount &&
                                                props.errors.additionalamount && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionalamount}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Reduced withholding: If you expect to receive a refund (as a result of itemized deductions, modifications or tax credits) on your tax return, you may direct your employer to only withhold the amount indicated on line 3. Your employer will not use the standard calculations for withholding. If you designate an amount that is too low, it could result in you being under withheld. To calculate the amount needed, divide the amount of your expected tax by the number of pay periods in a year. Enter the amount to be withheld instead of the standard calculation. If no amount is indicated on line 3, the standard calculations will be used'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.reducedwithholding}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('reducedwithholding')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.reducedwithholding &&
                                            props.errors.reducedwithholding && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.reducedwithholding as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Exempt Status: Select the appropriate reason you are claiming an exemption from withholding below and indicate EXEMPT on line 4'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Exempt Status: Select the appropriate reason you are claiming an exemption from withholding below and indicate EXEMPT on line 4"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.exemptstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('exemptstatus', option)
                                                if (option !== null && option !== '') {
                                                    props.setFieldValue('additionalamount', '')
                                                }
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.exemptstatus &&
                                            props.errors.exemptstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.exemptstatus as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default MoInformationform
